<ng-container *transloco="let t;">
    <mat-toolbar class="tool-bar">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center"
            style="background-color: #ea7600; min-height:50px;height:50px;">
            <h1 fxFlex style="color: white; font-size: 16px; font-weight: bold;">{{
                t('DocumentArchive.referenceDocument') }}</h1>
            <button style="color: white;" mat-icon-button class="close-button" style="margin-left: 272px;">
                <mat-icon (click)="closeDialog()">close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div>
        <mat-dialog-content class="dialog-content no-padding">
            <div class="custom-table-wrapper">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 full-width"
                    *ngIf="dataSource.length > 0">

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="checkbox-header">
                            <mat-checkbox (change)="masterToggle()" [checked]="isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()" [disabled]="isDisabled">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row" class="checkbox-cell">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)"
                                [checked]="selection.isSelected(row)" [disabled]="row.isDisabled">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="urls">
                        <th mat-header-cell *matHeaderCellDef class="url-header">Document URL</th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <button mat-icon-button color="accent" (click)="openHistory(element)"
                                    matTooltip="View History">
                                    <mat-icon>history</mat-icon>
                                </button>

                                <span>{{ extractFileName(element.urls) }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="upload">
                        <th mat-header-cell *matHeaderCellDef class="url-header"></th>
                        <td mat-cell *matCellDef="let element" class="url-cell">

                            <input type="file" #fileInput hidden multiple accept=".jpeg,.jpg,.pdf,.doc,.docx,.xls,.xlsx"
                                (change)="onFileSelected($event, element)"
                                [disabled]="!data.canEdit || element.status === 'Approved' || element.status === 'Approve'" />

                            <button mat-icon-button color="primary" (click)="fileInput.click()"
                                style="margin-top: 11px;"
                                [disabled]="!data.canEdit || element.status === 'Approved' || element.status === 'Approve' || element.stateName === 'RequestCompleted'"
                                [ngStyle]="{ 'background-color': !data.canEdit || (element.status === 'Approved' || element.status === 'Approve') || element.stateName === 'RequestCompleted' ? '#e0e0e0' : 'transparent' }"
                                matTooltip="Reupload Document">
                                <mat-icon>upload_file</mat-icon>
                            </button>

                            <div style="margin-top: 8px; max-height: 100px; overflow-y: auto;">
                                <div *ngFor="let file of element.uploadedFiles; let j = index"
                                    style="display: flex; align-items: center; justify-content: space-between; padding: 4px 0; border-bottom: 1px solid #e0e0e0;">
                                    <span>📎 {{ file.name }} ({{ file.size | number }} bytes)</span>
                                    <button mat-icon-button color="warn" (click)="removeUploadedFile(element, j)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="comments">
                        <th mat-header-cell *matHeaderCellDef class="url-header">Comments</th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <mat-form-field appearance="outline" class="full-width" style="margin-top: 5px;">
                                <input matInput placeholder="Enter comments" [(ngModel)]="element.comments"
                                    [disabled]="!element.uploadedFiles || element.uploadedFiles.length === 0">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="recipient">
                        <th mat-header-cell *matHeaderCellDef>Recipient</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full" style="margin-top: 5px;">
                                <mat-select placeholder="Select Recipient" [(ngModel)]="element.recipientId"
                                    name="recipient-{{ element.id }}"
                                    [disabled]="element.recipientDisabled || element.stateName === 'RequestCompleted' ||
                                                      (element.stateName === 'SubmittedToReview' && !data.reviewer && !data.admin)">
                                    <mat-option *ngFor="let user of element.availableRecipients"
                                        [value]="user.userName">
                                        {{ user.userName }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="info">
                        <th mat-header-cell *matHeaderCellDef class="url-header"></th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <button mat-icon-button color="primary" matTooltip="State: {{ element.stateName }}"
                                matTooltipPosition="above">
                                <mat-icon>info</mat-icon>
                            </button>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="decision">
                        <th mat-header-cell *matHeaderCellDef>Decision</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="outline" class="w-full" style="margin-top: 5px;">
                                <mat-select placeholder="Select Decision"
                                    (selectionChange)="onDecisionChange(element, $event.value)"
                                    [disabled]="element.stateName === 'RequestCompleted' || (element.stateName === 'SubmittedToReview' && !data.reviewer && !data.admin)">
                                    <mat-option *ngIf="element.stateName === 'Start'" value="SubmittedToReview">
                                        Submitted To Review
                                    </mat-option>
                                    <mat-option *ngIf="element.stateName === 'SubmittedToReview'" value="NeedMoreInfo">
                                        Need More Info (Return to Start)
                                    </mat-option>
                                    <mat-option *ngIf="element.stateName === 'SubmittedToReview'"
                                        value="RequestCompleted">
                                        Request Completed
                                    </mat-option>
                                    <mat-option *ngIf="element.stateName === 'RequestCompleted'" disabled>
                                        Request Completed
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="url-header">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <span *ngIf="element.status === 'Approve' || element.status === 'Approved'"
                                style="color: green; font-weight: 500;">
                                Approved
                            </span>
                            <span *ngIf="element.status === 'Reject' || element.status === 'Rejected'"
                                style="color: red; font-weight: 500;">
                                Rejected
                            </span>
                            <span *ngIf="!element.status" style="color: gray;">
                                Pending
                            </span>
                        </td>

                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="url-header">
                            {{ t('siteInspection.Action') }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <div class="action-buttons-wrapper">
                                <button mat-icon-button color="primary" (click)="saveRow(element)"
                                    [disabled]="!data.reviewer || element.status === 'Approve' || element.status === 'Approved'"
                                    matTooltip="Approve Document"
                                    [ngStyle]="{ 'background-color': (!data.reviewer || element.status === 'Approve' || element.status === 'Approved') ? '#e0e0e0' : 'transparent' }">
                                    <mat-icon [style.color]="element.status === 'Approve' ? 'gray' : 'green'">
                                        check
                                    </mat-icon>
                                </button>
                                <button mat-icon-button color="warn" [disabled]="!data.reviewer"
                                    (click)="cancelRow(element)" matTooltip="Reject Document"
                                    [ngStyle]="{ 'background-color': !data.reviewer  ? '#e0e0e0' : 'transparent' }">
                                    <mat-icon style="color: red;">close</mat-icon>
                                </button>

                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="saveFile">
                        <th mat-header-cell *matHeaderCellDef class="url-header"></th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <button mat-icon-button color="primary" (click)="saveFile(element)" matTooltip="Save"
                                [disabled]="!data.canEdit || (element.status === 'Approved' || element.status === 'Approve') || element.stateName === 'RequestCompleted'"
                                [ngStyle]="{ 'background-color': (element.status === 'Approved' || element.status === 'Approve') || element.stateName === 'RequestCompleted' ? '#e0e0e0' : 'transparent' }">
                                <mat-icon>save</mat-icon>
                            </button>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="visibility">
                        <th mat-header-cell *matHeaderCellDef class="url-header"></th>
                        <td mat-cell *matCellDef="let element" class="url-cell">
                            <button mat-icon-button color="primary" (click)="openInfoDialog(element)"
                                matTooltip="View Info">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [matTooltip]="row.stateName === 'Start' && row.actionType === 'N'
                              ? 'Need More Info': row.stateName" matTooltipPosition="above" matTooltipShowDelay="300"
                        class="hoverable-row">
                    </tr>
                </table>

                <p *ngIf=" noDocumentsFound" class="no-docs-msg">No documents found for this form.</p>
            </div>
        </mat-dialog-content>

        <div fxLayout="row" class="dialog-actions">
            <button mat-flat-button type="submit" color="primary" [disabled]="!data.canEdit || selection.isEmpty()"
                (click)="downloadSelected()">
                {{ t('DocumentArchive.download') }}
            </button>

            <!-- Delete button -->
            <button mat-flat-button type="submit" color="primary" [disabled]="!data.canDelete || selection.isEmpty()"
                (click)="deletesectedfile()">
                {{ t('DocumentArchive.delete') }}
            </button>
            <button mat-flat-button type="submit" color="primary" (click)="onSubmit()" [disabled]="selection.isEmpty()">
                Submit
            </button>
            <button mat-stroked-button color="primary" (click)="closeDialog()">
                {{ t('siteInspection.Cancel') }}
            </button>
        </div>
    </div>
</ng-container>